import { render, staticRenderFns } from "./VendorUnitDetails.vue?vue&type=template&id=2add858d"
import script from "./VendorUnitDetails.vue?vue&type=script&lang=js"
export * from "./VendorUnitDetails.vue?vue&type=script&lang=js"
import style0 from "./VendorUnitDetails.vue?vue&type=style&index=0&id=2add858d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports